export default "dist/images/components-columns-width-control-3-3-grid.1ea783e.png";